import { baseRestApi } from '@src/utils/rtkQuery';

type ExternalRefDataItem = {
  Code: string;
  DisplayName: string;
};

// Types for the reference data items
type BusinessDayConvention = ExternalRefDataItem;
type CountryCode = ExternalRefDataItem;
type Calendar = ExternalRefDataItem;
type DayCountConvention = ExternalRefDataItem;

const externalRefDataEndpoints = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    getBusinessDayHolidayConventions: builder.query<BusinessDayConvention[], void>({
      query: () => ({ method: 'GET', url: '/external-ref-data/business-day-holiday-conventions' }),
    }),

    getCountryCodes: builder.query<CountryCode[], void>({
      query: () => ({ method: 'GET', url: '/external-ref-data/country-codes' }),
    }),

    getCalendars: builder.query<Calendar[], void>({
      query: () => ({ method: 'GET', url: '/external-ref-data/calendars' }),
    }),

    getDayCountConventions: builder.query<DayCountConvention[], void>({
      query: () => ({ method: 'GET', url: '/external-ref-data/day-count-conventions' }),
    }),
  }),
});

export const {
  useGetBusinessDayHolidayConventionsQuery,
  useGetCountryCodesQuery,
  useGetCalendarsQuery,
  useGetDayCountConventionsQuery,
} = externalRefDataEndpoints;
